export default "__VITE_ASSET__Cl5MhN5___"